<template>
  <div class="toast fade p-2 mt-2 position" :class="{
    'show': show,
    ...getColor(color)
  }">
    <div class="toast-header bg-transparent border-0">
      <i class="me-2 icon-header" :class="getIcon(icon)" />
      <span class="me-auto font-weight-bold" :class="getTextColor(color)">
        {{ title }}
      </span>
      <small :class="getTextColor(color)">{{ date }}</small>
      <i
        class="fas fa-times text-md ms-3 cursor-pointer"
        :class="getTextColor(color)"
        @click="closeSnackBar()"
      />
    </div>
    <hr class="horizontal m-0" :class="getHrColor(color)" />
    <div class="toast-body" :class="getTextColor(color)">{{ description }}</div>
  </div>
</template>

<script>
export default {
  name: "SoftSnackbar",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    icon: {
      type: [String, Object],
      component: {
        type: String,
      },
      color: {
        type: String,
      },
      default: () => ({
        color: "success",
      }),
    },
    color: {
      type: String,
      default: "success",
    },
    closeHandler: {
      type: Function,
      default: null,
    },
  },
emits: ['close-handler'],
  watch: {
    // eslint-disable-next-line no-unused-vars
    show(newValue, _oldValue) {}
  },
  methods: {
    getColor: () => {
      /* if (color === "white") {
        return { "bg-white": true };
      } else {
        let key = `bg-gradient-${color}`
        return {[key]: true };
      } */
      return { "bg-white": true };
    },
    getIcon(icon) {
      if (icon && typeof icon === "string") {
        return icon;
      } else if (icon && typeof icon === "object") {
        return `${icon.component} text-${icon.color}`;
      } else {
        return null;
      }
    },
    closeSnackBar() {
      this.$emit("close-handler")
    },
    getTextColor: (color) => (color !== "white" ? color : "text-white"),
    getHrColor: (color) => (color === "white" ? "primary" : "light"),
  }
};
</script>
<style scoped>
.icon-header {
  font-size: 20px;
}
.text-header {
  font-size: 20px;
}
.position {
  z-index: 100050 !important;
}
</style>
